module.exports = __webpack_public_path__ + "files/22b4eaafb1052f661c69e9c72c8e148d.png";